module.exports = __webpack_public_path__ + "media/application/images/svgs/public_square/fallback_yellow-6554dbaac4327c0cfd2e8cd2bab97392.svg";